export const brandingTestEmailTemplates = {
  enquiryAutoResponse: 'enquiry_auto_response',
  enquiryAutoResponseForAProperty: 'enquiry_auto_response_for_a_property',
}

export const brandingTestEmailTemplatesOptions = {
  [brandingTestEmailTemplates.enquiryAutoResponse]: 'Enquiry auto-response',
  [brandingTestEmailTemplates.enquiryAutoResponseForAProperty]:
    'Enquiry auto-response for a property',
}
